<template>
  <b-dropdown
      block
      :text="text"
      :variant="variant"
      @shown="$refs['filterOptions'].focus()"
      @hidden="filterOptions = ''"
  >
    <b-dropdown-form class="pb-2">
      <b-input v-model="filterOptions" size="sm" ref="filterOptions" autocomplete="off"></b-input>
    </b-dropdown-form>

    <div class="px-3 pb-2 border-bottom">
      <b-form-checkbox
          :checked="isAllSelected"
          :indeterminate="isIndeterminate"
          @change="toggleSelectAll"
      >
        {{ isAllSelected ? $t('Clear all') : $t('Select all') }}
      </b-form-checkbox>
    </div>

    <b-form-checkbox-group
        class="px-2 pt-2"
        style="max-height: 200px; overflow-y: auto;"
        v-model="model"
        :options="showFilteredOptions"
        :name="inputName"
        stacked
    ></b-form-checkbox-group>
  </b-dropdown>
</template>

<script>
export default {
  name: "MultiselectFilterDropdown",
  props: ['options', 'inputName', 'value', 'text', 'variant'],
  data() {
    return {
      model: this.value || [],
      filterOptions: ''
    }
  },
  computed: {
    showFilteredOptions() {
      if (!this.options) {
        return [];
      }
      return this.options.filter(item => item.text.toLowerCase().includes(this.filterOptions.toLowerCase()))
    },

    isAllSelected() {
      if (!this.options || this.options.length === 0) return false;
      return this.options.every(item => this.model.includes(item.value));
    },

    isIndeterminate() {
      if (!this.options || this.options.length === 0) return false;
      const selectedCount = this.options.filter(item => this.model.includes(item.value)).length;
      return selectedCount > 0 && selectedCount < this.options.length;
    }
  },
  methods: {
    toggleSelectAll(checked) {
      if (checked) {
        this.model = this.options.map(item => item.value);
      } else {
        this.model = [];
      }
    }
  },
  watch: {
    value() {
      this.$set(this, 'model', this.value || []);
    },
    model() {
      this.$emit('input', this.model);
    },
  }
}
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}
</style>